import React from 'react';
import PropTypes from 'prop-types';
import { FacebookShareButton } from 'react-share';
import SocialShareAtag from '../Shared/SocialShareAtag';
import Container from '../Shared/Container';
import ButtonContainer from '../Shared/ButtonContainer';
import Icon from '../Shared/Icon';
import IconText from '../Shared/IconText';

const FbSocialShareButton = (props) => (
  <Container>
    <FacebookShareButton url={props.url} style={{ outline: 'none' }}>
      <SocialShareAtag backgroundColor="#4367b2">
        <ButtonContainer>
          <Icon>
            <svg
              viewBox="0 0 33 33"
              width="16"
              height="16"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <g>
                <path d="M29 0h-26c-1.65 0-3 1.35-3 3v26c0 1.65 1.35 3 3 3h13v-14h-4v-4h4v-2c0-3.306 2.694-6 6-6h4v4h-4c-1.1 0-2 0.9-2 2v2h6l-1 4h-5v14h9c1.65 0 3-1.35 3-3v-26c0-1.65-1.35-3-3-3z" />
              </g>
            </svg>
          </Icon>
          <IconText>Share</IconText>
        </ButtonContainer>
      </SocialShareAtag>
    </FacebookShareButton>
  </Container>
);

FbSocialShareButton.propTypes = {
  url: PropTypes.string.isRequired,
};

export default FbSocialShareButton;
